import styled from "styled-components";

export const ProductDetailWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;
`;
